export const actionTypes = {
  ON_USER_DATA: "on-user-data",
  ON_USER_ERROR: "on-user-data",
  ON_USER_LOADING: "on-user-loading",
  ON_QUERY_USER_DATA: "on-query-user-data",
  ON_USER_SUCCESS: "on-user-success",
  ON_DELETE_USER_SUCCESS: "on-delete-user-success",
  ON_DELETE_USER_LOADING: "on-delete-user-loading",
};

export const initialState = {
  users: [],
  loginLoading: false,
  userDataLoading: false,
  loginError: null,
  count: 0,
  userError: null,
  total: 0,
  userDeleteLoading: false,
};
